export const ExaminationResults = () => {
  return (
    <div>
      <p>This is the "The University" page</p>
    </div>
  );
};
